import {generateColumnsTable} from "src/modules/shared/data-transformer/utils";

const convertVigeoPricesResponseIntoTable = (response, format) => {
  console.debug('[VigeoToTableDatatransformer]', 'convertVigeoPricesResponseIntoTable')
  const possibleLineHeaders = ['Sans Retraité +', 'Avec Retraité']

  const datas = []
  let numberOfLevel = 0
  let previousLevel = 0
  Object.keys(response).forEach(key => {
    const value = response[key]

    // on considère qu'un noeud ressemblera toujours à  ce style "H1D1M1P1S0": "57,26 €" et dans l'ordre
    const levelSplit = key.substring(1, key.length-1).split('D')
    const levelNumber = parseInt(levelSplit[0])

    const lineSplit = key.split('S')
    const lineNumber = parseInt(lineSplit[lineSplit.length-1])
    
    if(previousLevel !== levelNumber) {
      numberOfLevel++
      previousLevel = levelNumber
    }
    const cellValue = { label:value }
    datas[lineNumber] = typeof datas[lineNumber] === 'undefined' ? [{label:possibleLineHeaders[lineNumber]}, cellValue]:[...datas[lineNumber], cellValue]
  })

  const columns = generateColumnsTable(numberOfLevel, format, 'Niveau')
  return {
    columns,
    datas,
    numberOfLevel
  }
}

export { convertVigeoPricesResponseIntoTable }
